export enum ChargerInstallationStatus {
	YES = 'YES',
	NO = 'NO',
	COMING_SOON = 'COMING_SOON',
}
